import AdHistoryContainer from './AdHistory.container';
import AdHistoryTable from './components/AdHistoryTable';
import AdHistory from './components/AdHistory';

export { AdHistoryTable, AdHistory };

export default AdHistoryContainer;
